import { __ } from "@wordpress/i18n";
import { useEffect, useState } from "@wordpress/element";

import { PanelBody, PanelRow, Button } from "@wordpress/components";
import BColor from "../../../../../components/BColor/BColor";
import BMediaUpload from "../../../../../components/BMediaUpload/BMediaUpload";
import BUnitControl from "../../../../../components/BUnitControl/BUnitControl";
import BDevice from "../../../../../../../Components/BDevice/BDevice";
import { BControlPro } from "../../../../../../../wp-utils/v1/components/";

const Style = ({ attributes, setAttributes }) => {
  const { styles, woo, currentViewer } = attributes;
  const { width, height, bgColor, bgImage, progressBar, progressBarColor, thumbSize = "90px" } = styles;

  const [device, setDevice] = useState("desktop");

  useEffect(() => {
    if (typeof height === "string") {
      setAttributes({
        styles: {
          ...styles,
          height: {
            desktop: height,
            tablet: height,
            mobile: height,
          },
        },
      });
    }
    if (typeof width === "string") {
      setAttributes({
        styles: {
          ...styles,
          width: {
            desktop: width,
            tablet: width,
            mobile: width,
          },
        },
      });
    }
  }, []);

  return (
    <PanelBody title={__("Style", "model-viewer")}>
      {!woo && (
        <PanelRow className="deviceForUnit">
          <label>{__("Width", "model-viewer")}</label>
          <BUnitControl
            value={width[device]}
            onChange={(width) => setAttributes({ styles: { ...styles, width: { ...styles.width, [device]: width } } })}
            units={[
              { value: "px", label: "px", default: 500 },
              { value: "%", label: "%", default: 100 },
            ]}
          />
          <BDevice device={device} onChange={(device) => setDevice(device)} />
        </PanelRow>
      )}
      <PanelRow className="deviceForUnit">
        <label>{__("Height", "model-viewer")}</label>
        <BUnitControl
          value={height[device]}
          onChange={(height) => setAttributes({ styles: { ...styles, height: { ...styles.height, [device]: height } } })}
          units={[
            { value: "px", label: "px", default: 500 },
            { value: "%", label: "%", default: 100 },
            { value: "vh", label: "vh", default: 100 },
          ]}
        />
        <BDevice device={device} onChange={(device) => setDevice(device)} />
      </PanelRow>
      <BUnitControl
        label={__("Thumb Size", "model-viewer")}
        value={thumbSize}
        onChange={(thumbSize) => setAttributes({ styles: { ...styles, thumbSize } })}
        units={[{ value: "px", label: "px", default: 100 }]}
      />
      <PanelRow>
        <label>{__("Background Color", "model-viewer")}</label>
        <BColor value={bgColor || "#ffffff"} defaultColor="#ffffff" onChange={(bgColor) => setAttributes({ styles: { ...styles, bgColor } })} />
      </PanelRow>
      {currentViewer === "modelViewer" && (
        <>
          <PanelRow>
            <label>
              <strong>{__("Note: Color will be ignore if background image used", "model-viewer")}</strong>
            </label>
          </PanelRow>
          <br />
          <PanelRow>
            <BControlPro
              Component={BMediaUpload}
              media={true}
              label={__("Background Image", "model-viewer")}
              placeholder={__("Background Image", "model-viewer")}
              value={bgImage}
              onSelect={(bgImage) => setAttributes({ styles: { ...styles, bgImage } })}
            />
          </PanelRow>
          {progressBar && (
            <PanelRow>
              <label>{__("ProgressBar Color", "model-viewer")}</label>
              <BColor value={progressBarColor || "#666"} defaultColor="#666" onChange={(progressBarColor) => setAttributes({ styles: { ...styles, progressBarColor } })} />
            </PanelRow>
          )}
        </>
      )}
    </PanelBody>
  );
};

export default Style;
